/**
 * Joins the given path segments into a single path
 *
 * The resulting path string will
 * 1. have a leading or trailing '/' if the first/last valid segments have leading/trailing slashes
 * 2. make sure that segments are separated by one slash '/'
 * 3. exclude invalid paths (empty strings or just empty space or just slash)
 *
 * @param segments the path segments to join
 */
export const joinPath = (...segments: string[]): string => {
    const validSegments = segments.filter(
        segment => segment?.trim()?.replace(/^\/+|\/+$/g, '').length > 0
    );
    return validSegments.join('/').replace(/\/+/g, '/');
};
